import { platforms } from '@/mocks/home';

export function DownloadSection() {
  return (
    <section id="download" className="w-full py-20 md:py-28 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
            选择您的平台，立即下载
          </h2>
          <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto leading-relaxed">
            91浏览器全面支持 Windows、macOS、Android 和 iOS，跨设备同步，无缝衔接
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {platforms.map((platform) => (
            <a
              key={platform.name}
              href={platform.href}
              className="group p-6 md:p-7 rounded-xl bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/15 hover:border-white/30 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-white/15 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <i className={`${platform.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-white mb-1">
                {platform.name}
              </h3>
              <p className="text-xs text-white/50 mb-3">{platform.description}</p>
              <div className="flex items-center justify-center gap-3 text-xs text-white/60 mb-4">
                <span>{platform.version}</span>
                <span className="w-1 h-1 rounded-full bg-white/30"></span>
                <span>{platform.size}</span>
              </div>
              <span className="inline-flex items-center gap-1.5 px-5 py-2 bg-white text-primary-600 text-sm font-semibold rounded-lg group-hover:bg-white/90 transition-colors whitespace-nowrap">
                <i className="ri-download-line"></i>
                下载
              </span>
            </a>
          ))}
        </div>

        <div className="mt-12 p-5 md:p-6 rounded-xl bg-white/8 border border-white/10 text-center">
          <p className="text-sm text-white/70">
            <i className="ri-information-line mr-1.5"></i>
            所有版本均为官方正版，经过严格安全检测。下载安装即表示同意
            <a href="#" className="underline text-white/90 hover:text-white mx-1 cursor-pointer">服务条款</a>
            和
            <a href="#" className="underline text-white/90 hover:text-white mx-1 cursor-pointer">隐私政策</a>
          </p>
        </div>
      </div>
    </section>
  );
}